<!-- @format -->
<script lang="ts">
  import { onMount } from "svelte";
  import { getStoresContext } from "~/stores";
  import PinkWave from "../common/PinkWave.svelte";
  import StoreOwnImg from "./StoreOwnImg.svelte";
  import BodyContent, { NONE } from "../BodyContent.svelte";
  import type { StoresKey } from "~/stores";
  import type { ManageAPI } from "~/manage-api/types";
  import OutlineTitle from "../common/OutlineTitle.svelte";
  import Carousel from "../offers/Carousel.svelte";
  import OfferCard from "../offers/OfferCard.svelte";

  export let request_store_key: StoresKey;
  export let prefetched_offers: ManageAPI.Offer[] = [];
  
  const {
    store,
    T,
    offers,
  } = getStoresContext(request_store_key);

  $: t = $T;
  let isVisible = false; // Control visibility to prevent FOUC

  // Use prefetched offers if available, otherwise filter from store
  $: storeOffers = prefetched_offers.length > 0 
    ? prefetched_offers 
    : $offers.filter((offer) => offer?.store?.id == $store.id);
    
  let id = 0;
  function focusOffer(event: CustomEvent) {
    id = event.detail;
  }

  // Make component visible once mounted
  onMount(() => {
    // Short delay to ensure styles are applied
    setTimeout(() => {
      isVisible = true;
    }, 100);
  });
</script>

<div class="mylly-store-offers-container" class:is-visible={isVisible}>
  <PinkWave will_be={"above"}>
    <BodyContent padding={NONE}>
      {#if !$store?.offerCount}
        <StoreOwnImg {request_store_key}></StoreOwnImg>
      {:else}
        <OutlineTitle styles={{ fill: "transparent", stroke: "#fa4616" }}>
          <div class="offer-title">{t`offers-and-services`}</div>
        </OutlineTitle>
        <!-- Offer carousel -->
        <Carousel slidesCount={storeOffers?.length} showPagination={false}>
          <svelte:fragment slot="swiper">
            {#each storeOffers as offer}
              <div class="swiper-slide">
                <OfferCard
                  {offer}
                  bordered={false}
                  on:focusOffer={focusOffer}
                  {request_store_key}
                  isStoreOwnPage={true}></OfferCard>
              </div>
            {/each}
          </svelte:fragment>
        </Carousel>
      {/if}
    </BodyContent>
  </PinkWave>
</div>

<style lang="scss">
  .mylly-store-offers-container {
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.3s ease;
    
    &.is-visible {
      visibility: visible;
      opacity: 1;
    }
    
    :global(.swiper-slide) {
      padding: 0 5px;
      
      @media screen and (min-width: 576px) {
        padding: 0;
      }
    }
  }
  
  .offer-title {
    padding-top: 40px;
    text-align: center;
    margin-bottom: 20px;
  }
</style> 